export function initFaqAccordion() {
    const faqItems = Array.from(document.querySelectorAll('.faq-item'));

    if (faqItems.length === 0) return;

    const closeItem = (item) => {
        const btn = item.querySelector('.faq-btn');
        const content = item.querySelector('.faq-content');
        const icon = item.querySelector('.faq-icon');

        if (!btn || !content) return;

        content.style.maxHeight = '0px';
        content.classList.remove('opacity-100');
        content.classList.add('opacity-0');
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('text-[#4A9C2E]');
        if (icon) icon.classList.remove('rotate-180');
    };

    const openItem = (item) => {
        const btn = item.querySelector('.faq-btn');
        const content = item.querySelector('.faq-content');
        const icon = item.querySelector('.faq-icon');

        if (!btn || !content) return;

        content.style.maxHeight = `${content.scrollHeight}px`;
        content.classList.remove('opacity-0');
        content.classList.add('opacity-100');
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('text-[#4A9C2E]');
        if (icon) icon.classList.add('rotate-180');
    };

    faqItems.forEach((item) => {
        const btn = item.querySelector('.faq-btn');
        const content = item.querySelector('.faq-content');

        if (!btn || !content) return;

        content.style.maxHeight = '0px';
        btn.setAttribute('aria-expanded', 'false');

        btn.addEventListener('click', () => {
            const isOpen = btn.getAttribute('aria-expanded') === 'true';

            faqItems.forEach((otherItem) => {
                if (otherItem !== item) closeItem(otherItem);
            });

            if (isOpen) {
                closeItem(item);
            } else {
                openItem(item);
            }
        });
    });

    window.addEventListener('resize', () => {
        faqItems.forEach((item) => {
            const btn = item.querySelector('.faq-btn');
            const content = item.querySelector('.faq-content');

            if (!btn || !content) return;

            if (btn.getAttribute('aria-expanded') === 'true') {
                content.style.maxHeight = `${content.scrollHeight}px`;
            }
        });
    });
}
